
<app-masterpage>
</app-masterpage>
<div class="page-wrapper">
    <app-header>
    </app-header>
    <div class="container-fluid pt-custom pb-5 ">
        <!-- onclick="outerbody();" -->
        <div class="row">
            <div class="col-lg-12">
                <div class="header">
                    <h4 class="title">Student Registration Report</h4>
                </div>
                <div class="row justify-content-center card">
                    <div class="col-lg-12 col-md-12 col-12 p-4">
                        <form #StudentRegReport="ngForm" (ngSubmit)="onSubmit()" class="pb-3">
                            <div class="row mt-2">
                                <div class="form-group col-lg-3 col-md-12 col-12">
                                    <label><b>State</b><span class="text-danger">*</span></label>
                                    <select class="form-control" #StateID="ngModel" ngModel name="StateID" id="StateID"
                                    (change)="fillCity()" [(ngModel)]="data.StateID" required>
                                    <option *ngFor="let state of states" [value]="state.value"
                                        [selected]="data.StateID == state.value">
                                        {{ state.text }}
                                    </option> </select>
                                    <span *ngIf="StudentRegReport.submitted ">
                                        <p *ngIf="data.StateID == 0 || data.StateID == undefined" class="error_message"
                                            style="color: red;">
                                            State is required
                                        </p>
                                    </span>
                                </div>
                                <div class="form-group col-lg-3 col-md-12 col-12">
                                    <label><b>City</b><span class="text-danger">*</span></label>
                                    <select class="form-control" #CityID="ngModel" ngModel name="CityID" id="CityID" (change)="fillSchoolArea(data.StateID,data.CityID)"
                                        [(ngModel)]="data.CityID" required>
                                        <option *ngFor="let city of cities" [value]="city.value"
                                            [selected]="data.CityID == city.value">
                                            {{ city.text }}
                                        </option>
                                    </select>
                                    <span *ngIf="StudentRegReport.submitted ">
                                        <p *ngIf="data.CityID == 0 || data.CityID == undefined" class="error_message"
                                            style="color: red;">
                                            City is required
                                        </p>
                                    </span>
                                </div>
                                <div class="form-group col-lg-3 col-md-12 col-12">
                                    <label><b>Area</b><span class="text-danger">*</span></label>
                                    <select class="form-control" #area="ngModel" ngModel name="area" id="area" (change)="fillSchoolName(data.StateID,data.CityID,data.area)"
                                        [(ngModel)]="data.area" required>
                                        <option *ngFor="let areax of areas" [value]="areax.text"
                                            [selected]="data.area == areax.text">
                                            {{ areax.text }}
                                        </option>
                                    </select>
                                    <span *ngIf="StudentRegReport.submitted ">
                                        <p *ngIf="data.area == 'Select' || data.area == undefined" class="error_message"
                                            style="color: red;">
                                            Area is required
                                        </p>
                                    </span>
                                </div>
                                <div class="form-group col-lg-3 col-md-12 col-12">
                                    <label><b>School Name</b><span class="text-danger">*</span></label>
                                    <select class="form-control" #SchoolID="ngModel" ngModel name="SchoolID" id = "SchoolID" 
                                        [(ngModel)]="data.SchoolID" required>
                                        <option *ngFor="let school of schools" [value]="school.value"
                                        [selected]="data.SchoolID == school.value">
                                            {{ school.text }}
                                        </option>
                                    </select>
                                    <span *ngIf="StudentRegReport.submitted ">
                                        <p *ngIf="data.SchoolID == 0 || data.SchoolID == undefined" class="error_message"
                                            style="color: red;">
                                            School Name is required
                                        </p>
                                    </span>
                                </div>
                            </div>
                            <div class="row">
                                <div class="form-group col-lg-1 col-md-1 col-5">
                                    <button type="button" (click)="onSubmit()" class="col-lg-12 btn btn-primary mr-3">Show</button>
                                </div>
                                <div class="form-group col-lg-4 col-md-2 col-7">
                                    <button type="button" id="btnExcel" (click)="ExportToExcel()" style="display: none;"
                                        class="btn btn-primary  mr-3">Export to
                                        excel</button>
                                </div>
                            </div>
                           
                            <div class="row" id="divclgList" style="display: none;"
                          >
                            <div class=" col-lg-12 col-md-12 col-12 p-4">
                                <div class="table-responsive">
                                    <table id="example" class="table table-striped table-bordered" style="width:100%">
                                        <thead>
                                            <tr>
                                                <!-- <th class="pointer"(click)="sortBy('Board')">Name</th> -->
                                                <th class="pointer" scope="col">Student Name</th>
                                                <th class="pointer" scope="col">Student MobileNo</th>
                                                <th class="pointer" scope="col">Student Email</th>
                                                <th class="pointer" scope="col">School Name</th>
                                                <th class="pointer" scope="col">School Code</th>
                                                <th class="pointer" scope="col">School Area</th>
                                                <th class="pointer" scope="col">School Address</th>
                                                <th class="pointer" scope="col">State</th>
                                                <th class="pointer" scope="col">City</th>
                                                <th class="pointer" scope="col">School MobileNo</th>
                                                <th class="pointer" scope="col">School Email</th>
                                                
                                            </tr>
                                        </thead>
                                        <tbody style="font-size: small;">
                                            <tr
                                                *ngFor="let r of registrationlist;let i = index">
                                                <td>
                                                    <p>{{r.StudentName}}</p>
                                                </td>
                                                <td>
                                                    <p>{{r.StudentMobileno}}</p>
                                                </td>
                                                <td>
                                                    <p>{{r.studentemailid}}</p>
                                                </td>
                                                <td>
                                                    <p>{{r.SchoolName}}</p>
                                                </td>
                                                <td>
                                                    <p>{{r.schoolcode}}</p>
                                                </td>
                                                <td>
                                                    <p>{{r.SchoolArea}}</p>
                                                </td>
                                                <td>
                                                    <p>{{r.SchoolAddress}}</p>
                                                </td>
                                                <td>
                                                    <p>{{r.State}}</p>
                                                </td>
                                                <td>
                                                    <p>{{r.City}}</p>
                                                </td>
                                                <td>
                                                    <p>{{r.Schoolmobileno}}</p>
                                                </td>
                                              <td>
                                                  <p>{{r.Schoolmailid}}</p>
                                              </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <!-- <div class="card-footer pb-3 pt-3 mb-4" align="center">
                                    <pagination-controls (pageChange)="p = $event"></pagination-controls>
                                </div> -->
                            </div>
                        </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <table class="table table-bordered" #TABLE style="display: none;">
        <thead>
            <tr>
               
                   <th scope="col">Student Name</th>
                   <th scope="col">Student MobileNo</th>
                   <th scope="col">Student Email</th>
                   <th scope="col">School Name</th>
                   <th scope="col">School Code</th>
                   <th scope="col">School Area</th>
                   <th scope="col">School Address</th>
                   <th scope="col">State</th>
                   <th scope="col">City</th>
                   <th scope="col">School MobileNo</th>
                   <th scope="col">School Email</th>
             </tr>
        </thead>
        <tbody>
            <tr *ngFor="let user of registrationlist">
                <td>
                    <p>{{user.StudentName}}</p>
                </td>
                <td>
                    <p>{{user.StudentMobileno}}</p>
                </td>
                <td>
                    <p>{{user.studentemailid}}</p>
                </td>
                <td>
                    <p>{{user.SchoolName}}</p>
                </td>
                <td>
                    <p>{{user.schoolcode}}</p>
                </td>
                <td>
                    <p>{{user.SchoolArea}}</p>
                </td>
                <td>
                    <p>{{user.SchoolAddress}}</p>
                </td>
                <td>
                    <p>{{user.State}}</p>
                </td>
                  <td>
                    <p>{{user.City}}</p>
                  </td>
                  <td>
                    <p>{{user.Schoolmobileno}}</p>
                </td>
               <td>
                  <p>{{user.Schoolmailid}}</p>
               </td>
            </tr>
        </tbody>
    </table>
    <div class="footer-login custom-footer">
        <p class="mb-0">Copyright © Netsol IT Solution Pvt. Ltd. 2020 All Rights Reserved</p>
        <img src="assets/images/powered-by.png" alt="netsol-powerd by" class="img-fluid">
    </div>
   <ngx-spinner bdcolor="rgba(51, 51, 51, 0.8)" size="default" type="ball-spin-clockwise">
    <p style="color: white;">Please Wait.</p>
</ngx-spinner>
</div>
